/* 序列帧插件

1、样式默认全屏
2、参数配置
  * canvas: '',  document.getElementById("testcanvas") canvas元素， 必传
  * imgUrl: '',  序列帧资源路径，需要图片名称为从0开始的递增序列，必传
  *              例如  图片名称，sixth_map0.jpg、sixth_map1.jpg、 sixth_map2.jpg ...
  *              传入  imgUrl: `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/sixth_map`
  * imgtype: '.jpg', 资源图片后缀，默认为 '.jpg',  必传
  * imgLenth: 35,  资源图片个数，默认35  非必传
  * timeSpan: 70,  序列帧自动播放时间间隔，单位ms，默认70ms  非必传
  * pictureCoefficient: 2,  图片倍数，如果图片为2倍图是，则传入2， 一倍图传1, 默认2  非必传
  * isFullscreen: false   全屏模式，启动后canvas将设置为全屏大小，会相对屏幕位置居中显示，需要再canvas父集设置overflow：hidden; 默认false  非必传
3、API
  * autoplay(),  序列帧自动播放
  * mouseplay(top, sums),  程度播放，通过多次调用实现播放，top为当前进度，sums为总进度或总路程最好为固定一个值，例如 mouseplay(1, 35);
  * 
*/ 

/*
let quence = new Sequence({
    canvas: document.getElementById("testcanvas"),
    imgLenth: 50,
    timeSpan: 70,
    imgUrl: `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/robo_q7_sixth_map`,
    imgUrl: `${BASE_URL}files/${PREFIXER}s1ban_`, //或者
    pictureCoefficient: 2,
    isFullscreen: false
});

quence.autoplay();
quence.mouseplay(top, 1000);
*/ 

class Sequence {
  constructor(options) {

    const defa = {
      id:'animation',
      canvas: '',
      imgLenth: 35,
      timeSpan: 70,
      imgUrl: '',
      imgtype: '.jpg',
      pictureCoefficient: 2,
      isFullscreen: false
    };

    if(!options.canvas){
      console.error('canvas为必传字段~~~~~~~~~~~ sequence.js');
      return;
    };
    if(!options.imgUrl){
      console.error('imgUrl为必传字段~~~~~~~~~~~ sequence.js');
      return;
    }
    this.fillZeroLength = options.fillZeroLength||false;
    this.id = options.id || defa.id;
    this.canvas = options.canvas;
    this.isFullscreen = options.isFullscreen || defa.isFullscreen;
    this.pictureCoefficient = options.pictureCoefficient || defa.pictureCoefficient;
    this.imgs=[];
    this.imgLenth = options.imgLenth || defa.imgLenth;
    this.timeSpan = options.timeSpan || defa.timeSpan;
    this.ctx = this.canvas.getContext("2d");
    this.imgUrl = options.imgUrl || defa.imgUrl;
    this.imgtype = options.imgtype || defa.imgtype;

    this.loop=options.loop || false; //循环
    this.paused = false; //暂停
    this.reversed = false;//倒放
    this.currentFrame=1; //当前播放桢

    this.timer = null;
    this.renderImgList = [];
    this.renderImgList.length = this.imgLenth;
    this.ScreenHeight = document.documentElement.clientHeight || window.innerHeight;
    this.ScreenWidth = document.documentElement.clientWidth || window.innerWidth;
    this.Fire = {
      animation6Ready: false,
      locked: false
    };

    
    this.init(options);
  }

  init(options) {
    this.readyImg();
  }
  //开始加载图片
  startLoadImg()
  {
    this.imgs?.forEach((img)=>{
      if(img.dataset.src)
      {
        img.src = img.dataset.src;
        delete img.dataset.src;
      }
    })

    // Promise.all(imglist).then(
    //   (res) => {
    //     this.Fire.animation6Ready = true;
    //   },
    //   (err) => {
    //     console.log("catch", err);
    //   }
    // );

  }
  winSize(w, h) {
    if (this.ScreenWidth / this.ScreenHeight > (w / h)) {
      this.canvasWidth = this.ScreenWidth;
      this.canvasHeight = this.ScreenWidth / (w / h);
    } else {
      this.canvasWidth = (w / h) * this.ScreenHeight;
      this.canvasHeight = this.ScreenHeight;
    }

    this.canvas.width = this.canvasWidth;
    this.canvas.height = this.canvasHeight;
    this.canvas.style.marginLeft = (this.ScreenWidth - this.canvasWidth) / 2 + "px";
    this.canvas.style.marginTop = (this.ScreenHeight - this.canvasHeight) / 2 + "px";
    
  }

  winSizeMob(w, h) {
    if (this.ScreenWidth / this.ScreenHeight > (w / h)) {
      this.canvasWidth = this.ScreenWidth;
      this.canvasHeight = this.ScreenWidth / (w / h);
    } else {
      this.canvasWidth = (w / h) * this.ScreenHeight;
      this.canvasHeight = this.ScreenHeight;
    }

    this.canvas.width = this.canvasWidth;
    this.canvas.height = this.canvasHeight;
    this.canvas.style.marginLeft = (this.ScreenWidth - this.canvasWidth) / 2 + "px";
    this.canvas.style.marginTop = (this.ScreenHeight - this.canvasHeight) / 2 + "px";

  }
  
  //准备图片
  readyImg() {
    let imglist = [];
    for (let i = 0; i < this.imgLenth; i++) {
      imglist.push(this.singleImg(i));
    }
    this.imgs=imglist;
    

    //监听canvas的可见性
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.startLoadImg();
        }
      });
    });
    observer.observe(this.canvas);
  }

  singleImg(ind) {
    // return new Promise((resolve, reject) => {
      let img = new Image();
      let _ind=this.fillZeroLength?ind.toString().padStart(this.fillZeroLength, '0'):ind;
      img.dataset.src = `${this.imgUrl}${_ind}${this.imgtype}`;
      img.onload = () => {
        this.renderImgList[ind] = img;
        if (ind == 0) {
          this.startCanvas0(img);
        }
        // resolve(img);
      };
      // setTimeout(() => {
      //   reject(ind);
      // }, 10000);

    // });
    return img
  }

  startCanvas0(img) {
    let img0 = img || this.renderImgList[0];
    if (img0) {
      let W = img.width/this.pictureCoefficient;
      let H = img.height/this.pictureCoefficient;
      if(this.isFullscreen){
        if (this.ScreenWidth > 750) {
          //PC端
          this.winSize(W, H);
          window.addEventListener(
            "resize",
            () => {
              clearTimeout(this.timer);
              this.timer = setTimeout(() => {
                this.winSize(W, H);
              }, 300);
            },
            false
          );
        } else {
          this.winSizeMob(W, H);
        };
      }else{
        this.canvas.style.width = '100%';
        this.canvas.width = W;
        this.canvas.height = H;
      };

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(img0, 0, 0, this.canvas.width, this.canvas.height);
    }else{
      this.canvas.style.width = '100%';
    }
  }

  autoplay(){
    // if (!this.Fire.animation6Ready){
    //   console.error('图片尚未加载完成，请等待~~~~~~~~~~~ sequence.js');
    //   return;
    // }
    if (this.Fire.locked) {
      return;
    }
    // console.time(this.id+'Play time---');
    this.Fire.locked = true;
    let _this = this;
    let coppart = this.renderImgList.slice(0);
    window.requestAnimationFrame(ani);
    let start;

    function ani(timestamp) {
      if (start === undefined)
        start = timestamp;
      let elapsed = timestamp - start;


      if(!_this.paused){
        if(_this.reversed)
          _this.currentFrame--;
        else
          _this.currentFrame++;

        if(_this.currentFrame >= _this.imgLenth){
          if(_this.loop)
            _this.currentFrame = 0;
        }
        if(_this.currentFrame < 0){
          if(_this.loop)
            _this.currentFrame = _this.imgLenth-1;
        }

        _this.currentFrame = Math.min(Math.max(0, _this.currentFrame), _this.imgLenth-1)
      }

      
      if(elapsed >= _this.timeSpan){
        let img = coppart[_this.currentFrame];
        if (img && img.complete) {
          _this.ctx.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
          _this.ctx.drawImage(img, 0, 0, _this.canvas.width, _this.canvas.height);
        } else {
          _this.Fire.locked = false;
          // console.timeEnd(_this.id+'Play time---');
          return; // 停止动画
        }
        start = timestamp;
      };
      window.requestAnimationFrame(ani);

    }
  }

  gotoAndPlay(frame,reversed=false)
  {
    this.paused=false;
    this.reversed=reversed;
    this.currentFrame = frame||this.currentFrame;
    this.autoplay();
  }

  gotoAndStop(frame)
  {
    this.paused=true;
    frame=parseInt(Math.min(Math.max(0,frame),this.imgLenth-1));
    this.currentFrame = frame;
    let cop = this.renderImgList.slice(0);
    let img = cop[frame];
    if(img?.complete){
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
    }
  }

  mouseplay(top, sums) {
    // if (!this.Fire.animation6Ready){
    //   console.error('图片尚未加载完成，请等待~~~~~~~~~~~ sequence.js');
    //   return;
    // }
    if(!top){
      return;
    }
    if (this.Fire.locked) {
      return;
    }
    let cop = this.renderImgList.slice(0);

    let fra = (sums)/this.imgLenth;
    let img = cop[Math.abs(parseInt(top/fra))];
    if(top >= 0){
        img = cop[0];
    }else if(top < -(sums) ){
        img = cop[this.imgLenth-1];
    };
    if(img && img.complete){
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
    }
    
  }
}
window.Sequence=Sequence;